/* CashNCarry Loot - browsing (Loot pages only; after cnc-loot-core.js). Rails and bubbles (arrow buttons), hero
   carousel (swipe, auto-advance with pause, dots, real-date countdown), "Just for you" grid (chips, Load more,
   infinite scroll), Saved page, Recently viewed rail, Loot search label. Vanilla JS. */
(function () {
  'use strict';
  var L = window.CncLoot; if (!L) return;
  var RM = L.RM, root = L.root;

  /* Rails and bubbles: arrows scroll by one view; disabled at the ends. */
  function railState(track) {
    var box = track.closest('.lr, .lb'); if (!box) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    var p = box.querySelector('[data-lr-prev]'), n = box.querySelector('[data-lr-next]');
    if (p) p.disabled = track.scrollLeft <= 2;
    if (n) n.disabled = track.scrollLeft >= max;
    box.classList.toggle('lr--fits', max <= 0);
  }
  function initRails(scope) {
    (scope || document).querySelectorAll('[data-lr-track]:not([data-lr-ok])').forEach(function (tr) {
      tr.dataset.lrOk = '1';
      tr.addEventListener('scroll', function () { railState(tr); }, { passive: true });
      railState(tr);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lr-prev],[data-lr-next]'); if (!b) return;
    var tr = document.getElementById(b.getAttribute('aria-controls')); if (!tr) return;
    tr.scrollBy({ left: (b.hasAttribute('data-lr-next') ? 1 : -1) * tr.clientWidth * 0.9, behavior: RM ? 'auto' : 'smooth' });
  });
  window.addEventListener('resize', function () { document.querySelectorAll('[data-lr-track]').forEach(railState); });

  /* Countdown to a real date (Black Friday, then Christmas). Hidden after Christmas. */
  function initCountdown(slide) {
    var bf = Date.parse(slide.dataset.bf), xm = Date.parse(slide.dataset.xmas), clock = slide.querySelector('[data-cd-clock]');
    function q(s) { return slide.querySelector(s); }
    function tick() {
      var now = Date.now(), target, isX;
      if (now < bf) { target = bf; isX = false; } else if (now < xm) { target = xm; isX = true; } else { slide.remove(); return false; }
      slide.querySelectorAll('[data-cd-bf]').forEach(function (n) { n.hidden = isX; });
      slide.querySelectorAll('[data-cd-x]').forEach(function (n) { n.hidden = !isX; });
      var s = Math.max(0, Math.floor((target - now) / 1000));
      q('[data-cd-d]').textContent = Math.floor(s / 86400);
      q('[data-cd-h]').textContent = String(Math.floor(s % 86400 / 3600)).padStart(2, '0');
      q('[data-cd-m]').textContent = String(Math.floor(s % 3600 / 60)).padStart(2, '0');
      q('[data-cd-s]').textContent = String(s % 60).padStart(2, '0');
      clock.hidden = false;
      return true;
    }
    if (tick()) var iv = setInterval(function () { if (!tick()) clearInterval(iv); }, 1000);
  }

  /* Hero carousel */
  function initHero(h) {
    h.querySelectorAll('[data-lh-cd]').forEach(initCountdown);
    var track = h.querySelector('[data-lh-track]'), slides = [].slice.call(h.querySelectorAll('[data-lh-slide]'));
    var dotsBox = h.querySelector('[data-lh-dots]'), pauseB = h.querySelector('[data-lh-pause]');
    if (!slides.length) { h.closest('.lsec') && h.closest('.lsec').remove(); return; }
    var cur = 0, timer = null, hold = 0, userPaused = RM;
    slides.forEach(function (s, i) {
      s.setAttribute('aria-label', L.t('slide', { n: i + 1, total: slides.length }));
      var d = document.createElement('button'); d.type = 'button'; d.className = 'lh__dot';
      d.setAttribute('aria-label', L.t('slide', { n: i + 1, total: slides.length }));
      d.addEventListener('click', function () { go(i); });
      dotsBox.appendChild(d);
    });
    if (slides.length < 2) { h.querySelector('.lh__ctl').hidden = true; }
    var dots = dotsBox.querySelectorAll('button');
    function mark(i) { cur = i; dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); }); }
    function go(i) { i = (i + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft, behavior: RM ? 'auto' : 'smooth' }); mark(i); }
    var st;
    track.addEventListener('scroll', function () {
      clearTimeout(st); st = setTimeout(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }, 80);
    }, { passive: true });
    function run() { stop(); if (userPaused || hold || slides.length < 2 || document.hidden) return; timer = setInterval(function () { go(cur + 1); }, 6000); }
    function stop() { clearInterval(timer); timer = null; }
    function pauseUI() { pauseB.setAttribute('aria-pressed', String(userPaused)); h.classList.toggle('lh--paused', userPaused); }
    pauseB.addEventListener('click', function () { userPaused = !userPaused; pauseUI(); run(); });
    h.addEventListener('mouseenter', function () { hold |= 1; stop(); });
    h.addEventListener('mouseleave', function () { hold &= ~1; run(); });
    h.addEventListener('focusin', function () { hold |= 2; stop(); });
    h.addEventListener('focusout', function (e) { if (!h.contains(e.relatedTarget)) { hold &= ~2; run(); } });
    track.addEventListener('touchstart', function () { hold |= 4; stop(); }, { passive: true });
    track.addEventListener('touchend', function () { setTimeout(function () { hold &= ~4; run(); }, 4000); }, { passive: true });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); } });
    document.addEventListener('visibilitychange', run);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { if (en[0].isIntersecting) { hold &= ~8; run(); } else { hold |= 8; stop(); } }).observe(h);
    mark(0); pauseUI(); run();
  }

  /* Fetch HTML helper */
  function html(url) { return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw r; return r.text(); }); }
  function frag(s) { var d = document.createElement('div'); d.innerHTML = s; return d; }
  function card(handle) {
    return html(root + '/products/' + encodeURIComponent(handle) + '?view=cnc-loot-card').then(function (s) { var c = frag(s).querySelector('[data-lc]'); if (!c) throw 0; return c; });
  }

  /* "Just for you" grid */
  function initGrid(g) {
    var grid = g.querySelector('[data-lg-grid]'), more = g.querySelector('[data-lg-more]'), all = g.querySelector('[data-lg-all]');
    var sent = g.querySelector('[data-lg-sentinel]'), stat = g.querySelector('[data-lg-status]'), base = g.querySelector('[data-lg-chip][aria-pressed="true"]').dataset.url;
    var next = more.dataset.next ? +more.dataset.next : 0, busy = false, auto = 0, req = 0;
    function setMore() { more.hidden = !next; if (next) more.href = base + '?page=' + next; }
    function load(page, replace) {
      if (busy && !replace) return; busy = true; var my = ++req;
      grid.setAttribute('aria-busy', 'true'); more.classList.add('is-busy'); more.textContent = L.t('loading');
      return html(base + '?view=cnc-loot-grid&sort_by=best-selling&page=' + page).then(function (s) {
        if (my !== req) return;
        var p = frag(s).querySelector('[data-lg-page]'); if (!p) throw 0;
        if (replace) grid.textContent = '';
        [].slice.call(p.children).forEach(function (c) { grid.appendChild(c); });
        next = p.dataset.next ? +p.dataset.next : 0;
        L.prep(grid);
      }).catch(function () { next = 0; }).finally(function () {
        if (my !== req) return;
        busy = false; grid.setAttribute('aria-busy', 'false'); more.classList.remove('is-busy'); more.textContent = L.t('more'); setMore();
        /* One short status line for screen readers (the grid itself is not a live region). */
        if (stat) { var n = grid.querySelectorAll('[data-lc]').length; stat.textContent = 'Showing ' + n + (n === 1 ? ' item' : ' items'); }
      });
    }
    more.addEventListener('click', function (e) { if (!next) return; e.preventDefault(); load(next); });
    g.querySelectorAll('[data-lg-chip]').forEach(function (c) {
      c.addEventListener('click', function () {
        if (c.getAttribute('aria-pressed') === 'true') return;
        g.querySelectorAll('[data-lg-chip]').forEach(function (o) { o.setAttribute('aria-pressed', String(o === c)); });
        base = c.dataset.url; all.href = base; auto = 0; next = 0; load(1, true);
      });
    });
    /* Infinite scroll for 3 pages, then the button takes over so the footer stays reachable. */
    if ('IntersectionObserver' in window && sent) {
      new IntersectionObserver(function (en) { if (en[0].isIntersecting && next && !busy && auto < 3) { auto++; load(next); } }, { rootMargin: '600px 0px' }).observe(sent);
    }
    setMore();
  }

  /* Saved page and Recently viewed rail: cards fetched one by one, kept in stored order. */
  function fill(box, handles, onDone) {
    var slots = handles.map(function () { var s = document.createElement('div'); box.appendChild(s); return s; }), got = 0;
    return Promise.all(handles.map(function (h, i) {
      return card(h).then(function (c) { slots[i].replaceWith(c); got++; return null; }, function () { slots[i].remove(); return h; });
    })).then(function (gone) { L.prep(box); initRails(box.closest('.lr') || box); onDone && onDone(got, gone.filter(Boolean)); });
  }
  function initSaved(ls) {
    var grid = ls.querySelector('[data-ls-grid]'), empty = ls.querySelector('[data-ls-empty]');
    var hs = L.saved();
    if (!hs.length) { empty.hidden = false; return; }
    fill(grid, hs.slice(0, 48), function (got, gone) {
      if (gone.length) L.sset('cncLootSaved', L.saved().filter(function (h) { return gone.indexOf(h) < 0; }));
      if (!got) empty.hidden = false;
    });
    document.addEventListener('cnc-loot:saved', function (e) {
      if (e.detail.saved) return;
      grid.querySelectorAll('[data-lc]').forEach(function (c) { if (c.dataset.handle === e.detail.handle) c.remove(); });
      if (!grid.querySelector('[data-lc]')) empty.hidden = false;
    });
  }
  var RK = 'cncLootRecent';
  function initRecent() {
    var pdp = document.querySelector('[data-lpdp]');
    var list = L.sget(RK); list = Array.isArray(list) ? list : [];
    var cur = pdp && pdp.dataset.handle;
    document.querySelectorAll('[data-lr-fill="recent"]').forEach(function (sec) {
      var ex = sec.dataset.exclude, hs = list.filter(function (h) { return h !== ex; }).slice(0, 12);
      if (!hs.length) return;
      var tr = sec.querySelector('[data-lr-track]');
      fill(tr, hs, function (got, gone) {
        tr.querySelectorAll('[data-lc]').forEach(function (c) { var w = document.createElement('div'); w.className = 'lr__cell'; c.replaceWith(w); w.appendChild(c); });
        if (got) { sec.hidden = false; railState(tr); }
        if (gone.length) L.sset(RK, (L.sget(RK) || []).filter(function (h) { return gone.indexOf(h) < 0; }));
      });
    });
    if (cur) { list = [cur].concat(list.filter(function (h) { return h !== cur; })).slice(0, 20); L.sset(RK, list); }
  }

  /* Loot search. The storefront search runs over the whole store, so on Loot the query gets " AND tag:Loot"
     (Loot products only, Loot-only result count). The suffix is hidden from the search box, headings and tab
     title. The theme's count line stays hidden (CSS) and a plain Loot label is shown instead. */
  var LT = ' AND tag:Loot';
  function initSearch() {
    if (!document.body.classList.contains('search-template')) return;
    var u = new URL(location.href), q = u.searchParams.get('q');
    if (!q) return;
    if (q.indexOf('tag:Loot') < 0) { u.searchParams.set('q', q.trim() + LT); u.searchParams.set('loot', '1'); location.replace(u.toString()); return; }
    var clean = q.replace(LT, '').replace('tag:Loot', '').trim();
    document.querySelectorAll('input[name="q"]').forEach(function (i) { if (i.value.indexOf('tag:Loot') > -1) i.value = clean; });
    document.title = document.title.split(LT).join('').split('tag:Loot').join('');
    var main = document.getElementById('MainContent'), w = document.createTreeWalker(main, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) if (n.nodeValue.indexOf('tag:Loot') > -1) n.nodeValue = n.nodeValue.split(LT).join('').split('tag:Loot').join('');
    var head = document.querySelector('.template-search__header'); if (!head || head.querySelector('.lsearch')) return;
    var p = document.createElement('p'); p.className = 'lsearch'; p.textContent = L.t('searchLoot', { terms: clean });
    head.appendChild(p);
  }
  /* Search forms on Loot pages (header, search page) submit a Loot-only query. */
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.action || f.action.indexOf('/search') < 0) return;
    var q = f.querySelector('input[name="q"]'); if (!q || !q.value.trim() || q.value.indexOf('tag:Loot') > -1) return;
    var h = document.createElement('input'); h.type = 'hidden'; h.name = 'q'; h.value = q.value.trim() + LT;
    q.removeAttribute('name'); f.appendChild(h);
    setTimeout(function () { q.setAttribute('name', 'q'); h.remove(); }, 1000);
  }, true);

  initRails();
  document.querySelectorAll('[data-lh]').forEach(initHero);
  document.querySelectorAll('[data-lg]').forEach(initGrid);
  document.querySelectorAll('[data-ls]').forEach(initSaved);
  initRecent();
  initSearch();
})();